import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useQueryGetDynamicPagePresets from '@/modules/client-setting/api/hooks/useQueryGetDynamicPagePresets'
import PresetGallery from '@/modules/client-setting/components/DynamicPagePresets/components/PresetGallery'
import ThemePresetSelector from '@/modules/client-setting/components/ThemePresetSelector'

function DynamicPagePresetsPage() {
	const { data, isLoading } = useQueryGetDynamicPagePresets()

	return (
		<PageContainer>
			<div className="space-y-12">
				<ThemePresetSelector />
				<PresetGallery data={data?.data || []} isLoading={isLoading} />
			</div>
		</PageContainer>
	)
}

const GuardedDynamicPagePresetsPage = withUserPermission(
	DynamicPagePresetsPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.WEB_SETTING],
	},
)

export default GuardedDynamicPagePresetsPage
